var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as Sentry from '@sentry/react';
import LogRocket from 'logrocket';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useLocalStorage } from 'react-use';
import { keysToCamel } from '~/utils/toCamelCase';
import generateRandomString from './actions/generate_random_string';
import getBPUserInfo from './actions/getBPUserInfo';
import performAuthRedirect from './actions/perform_auth_redirect';
import performAuthSignout from './actions/perform_auth_signout';
const AuthContext = createContext({});
const AuthProvider = (props) => {
    const location = useLocation();
    const [loginState, setLoginState, deleteLoginState] = useLocalStorage('loginState');
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const signIn = () => __awaiter(void 0, void 0, void 0, function* () {
        setIsAuthenticated(false);
        const bpUserInfoResponse = yield getBPUserInfo();
        if (bpUserInfoResponse.status === 200) {
            const userInfo = keysToCamel(yield bpUserInfoResponse.json());
            Sentry.setUser({
                name: userInfo.info.name,
                email: userInfo.info.email,
                ip_address: '{{auto}}',
            });
            LogRocket.identify(userInfo.info.email, {
                name: userInfo.info.name,
                email: userInfo.info.email,
            });
            setIsAuthenticated(true);
            return;
        }
        const state = generateRandomString(64);
        setLoginState({ [state]: location });
        let loginHint = '';
        if (window.location.host.split('.').length > 1) {
            const subDomain = window.location.host.split('.')[0];
            if (window.RG_CONFIG.SUB_DOMAIN_MAPPER.hasOwnProperty(subDomain)) {
                loginHint = window.RG_CONFIG.SUB_DOMAIN_MAPPER[subDomain];
            }
        }
        performAuthRedirect(state, loginHint);
    });
    useEffect(() => {
        signIn();
    }, []);
    const signOut = () => __awaiter(void 0, void 0, void 0, function* () {
        yield performAuthSignout();
        setIsAuthenticated(false);
        LogRocket.startNewSession();
        window.location.reload();
    });
    const val = {
        isAuthenticated,
        loginState,
        signOut,
        deleteLoginState,
    };
    return React.createElement(AuthContext.Provider, Object.assign({ value: val }, props));
};
const useAuth = () => {
    const ctx = useContext(AuthContext);
    if (ctx === undefined) {
        throw new Error('AuthContext can only be used under the AuthProvider');
    }
    return ctx;
};
export { AuthProvider, useAuth };
